import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { bindActionCreators } from "redux";
import { actionCreators } from "../state";
import { useHistory } from 'react-router-dom'
import { BackButton, DexxButton } from "../components/light/LightButton"
import { PageDescription } from "../components/typography/Typogtaphy";
import { AssetCategory } from "../PoolContext";
import LoadingContainer from "../components/utils/LoadingContainer";
import { getFullCategoryName } from "../functions/assets";

export default function IssueNewRoute(): JSX.Element {
    const dispatch = useDispatch()
    const actions = bindActionCreators(actionCreators, dispatch)
    let history = useHistory()

    const [assetCategories, setAssetCategories] = useState<any>([])

    useEffect(() => {
        actions.getAllAssetCategories(setAssetCategories)
    }, [])

    function handleCreateIssue(category: AssetCategory) {
        history.push({
            pathname: '/issuer/asset/manage',
            state: { category: category } as { category: AssetCategory }
        });
    }
    return (<>
        <LoadingContainer isReady={assetCategories !== undefined && assetCategories?.length > 0}>
            <div className="flex place-content-center mt-10">
                <div className="grid w-fit">
                    <div className="grid justify-center justify-items-center items-center">
                        <PageDescription title={<div>Issue a<br></br>New Asset</div>}
                            description={"Which kind of asset do you want to create?"}
                        />
                    </div>
                    <div className="grid mt-10" >
                        <div className="font-roboto py-2">
                            <div className="flex flex-col flex-wrap md:place-content-center place-content-center
                            gap-4 place-item-center">
                                {
                                    (assetCategories === undefined || assetCategories === undefined) ? null
                                        : assetCategories.map((cat: AssetCategory, i: number) => {
                                            const categoryName = getFullCategoryName(cat)
                                            return (
                                                <div className="" key={i}>
                                                    <DexxButton label={categoryName + " ASSET"} onClick={() => { handleCreateIssue(cat) }}
                                                        color3="succ2_light" color4="gray10"
                                                        className="rounded-lg px-2 py-3 cursor-pointer w-72" />
                                                </div>
                                            )
                                        })
                                }
                                <BackButton className=" bg-gray9 rounded-lg py-3 "/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </LoadingContainer>
    </>)
}
